// This was exported from the Toolbar in Tandem, but LMV doesn't have it.
export function shiftControls(right, top) {
    const toolbarSelector = '.adsk-viewing-viewer .adsk-toolbar.adsk-toolbar-vertical';
    const cubeSelector = '.viewcubeWrapper';
    const statusBarSelector = '.adsk-viewing-viewer .status-line';

    for (const element of document.querySelectorAll(toolbarSelector)) {
        translate(element, right, top);
    }

    for (const element of document.querySelectorAll(cubeSelector)) {
        translate(element, right, top);
    }

    for (const element of document.querySelectorAll(statusBarSelector)) {
        translate(element, right, top);
    }

    const bimWalkInfoButton = document.querySelector('#tooltip-info');
    if (bimWalkInfoButton) {
        translate(bimWalkInfoButton, right, top);
    }
}

const translate = (element, right, top) => {
    if (element.dataset.right === undefined) element.dataset.right = 0;
    if (element.dataset.top === undefined) element.dataset.top = 0;

    if (right !== undefined) element.dataset.right = right || 0;
    if (top !== undefined) element.dataset.top = top || 0;

    element.style.translate = `-${element.dataset.right}px ${element.dataset.top}px`;
}
